<template>
  <tr class="payments-row">
    <td>
      <TableRowAvatar :user="item" :path="`/p/${item.username || item.id}`" />
    </td>
    <td>
      <a :href="`mailto:${item.email}`" target="_blank">{{ item.email }}</a>
    </td>
    <td class="center-align">
      {{ accountTypes[item.account_type] }}
    </td>
    <td
      class="center-align onboarding-status"
      :class="`onboarding-status--${
        item.onboarding_details.has_hr ? 'Yes' : 'No'
      }`"
    >
      {{ item.onboarding_details.has_hr ? "Yes" : "No" }}
    </td>
    <td
      class="center-align onboarding-status"
      :class="`onboarding-status--${item.onboarding_details.w9_status}`"
    >
      <v-tooltip
        v-if="
          item.onboarding_details.w9_status == 'SIGNED' &&
          item.onboarding_details.w9_overridden
        "
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">{{
            statuses[item.onboarding_details.w9_status]
          }}</span>
        </template>
        <span>This agreement was signed offsite</span>
      </v-tooltip>
      <span v-else>{{ statuses[item.onboarding_details.w9_status] }}</span>
      <span
        v-if="
          item.onboarding_details.w9_status == 'SIGNED' &&
          !item.onboarding_details.w9_overridden
        "
        ><v-btn icon @click="downloadAgreement('w9')"
          ><v-icon>$download</v-icon></v-btn
        ></span
      >
    </td>
    <td
      class="center-align onboarding-status"
      :class="`onboarding-status--${item.onboarding_details.ach_status}`"
    >
      <v-tooltip
        v-if="
          item.onboarding_details.ach_status == 'SIGNED' &&
          item.onboarding_details.ach_overridden
        "
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">{{
            statuses[item.onboarding_details.ach_status]
          }}</span>
        </template>
        <span>This agreement was signed offsite</span>
      </v-tooltip>
      <span v-else>{{ statuses[item.onboarding_details.ach_status] }}</span>
      <span
        v-if="
          item.onboarding_details.ach_status == 'SIGNED' &&
          !item.onboarding_details.ach_overridden
        "
        ><v-btn icon @click="downloadAgreement('ach_authorization')"
          ><v-icon>$download</v-icon></v-btn
        ></span
      >
    </td>
    <td
      class="center-align onboarding-status"
      :class="`onboarding-status--${item.onboarding_details.msa_status}`"
    >
      <span>{{ statuses[item.onboarding_details.msa_status] }}</span>
      <span v-if="item.onboarding_details.msa_status == 'SIGNED'"
        ><v-btn icon @click="downloadAgreement('msa')"
          ><v-icon>$download</v-icon></v-btn
        ></span
      >
    </td>
    <td
      class="center-align onboarding-status"
      :class="`onboarding-status--${item.onboarding_details.ga_withholding_status}`"
    >
      <span>{{ statuses[item.onboarding_details.ga_withholding_status] }}</span>
      <span v-if="item.onboarding_details.ga_withholding_status == 'SIGNED'"
        ><v-btn icon @click="downloadAgreement('ga_withholding')"
          ><v-icon>$download</v-icon></v-btn
        ></span
      >
    </td>
    <td
      class="center-align onboarding-status"
      :class="`onboarding-status--${item.confirmed_at ? 'Yes' : 'No'}`"
    >
      {{ item.confirmed_at ? "Yes" : "No" }}
    </td>
    <td
      class="center-align onboarding-status"
      :class="`onboarding-status--${
        item.onboarding_details.qb_is_linked ? 'Yes' : 'No'
      }`"
    >
      {{ item.onboarding_details.qb_is_linked ? "Yes" : "No" }}
    </td>
    <td class="center-align">
      {{ item.created_at ? dateFormatted(item.created_at, "MM/DD/YYYY") : "" }}
    </td>
    <PleaseWaitDialog :dialog="pleaseWait" />
  </tr>
</template>

<script>
import TableRowAvatar from "@/components/work-assignments/TableRowAvatar.vue";
import paymentsTableFormats from "@/mixins/payments-table-formats.mixin";

export default {
  mixins: [paymentsTableFormats],
  components: { TableRowAvatar },
  props: {
    item: Object,
  },
  data() {
    return {
      statuses: {
        NONE: "None",
        SIGNED: "Signed",
        OUT_FOR_SIGNATURE: "Sent",
        CANCELLED: "Cancelled",
      },
      accountTypes: {
        individual: "Sole Proprietor",
        business: "Business",
      },
      pleaseWait: false,
    };
  },
  methods: {
    async downloadAgreement(type) {
      this.pleaseWaitTimeout = setTimeout(() => {
        this.pleaseWait = true;
      }, 200);
      const result = await this.$api.Agreement.documentByType({
        creator_id: this.item.id,
        agreement_type: type,
      });
      clearTimeout(this.pleaseWaitTimeout);
      this.pleaseWait = false;
      if (result.status == 200) {
        window.open(result.data.url, "_blank");
      } else {
        this.$alert(result.data.alert || "Something went wrong", "error");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/payments/payments-row.scss";

.onboarding-status {
  white-space: nowrap;
  font-weight: bold;
  &--NONE,
  &--No,
  &--CANCELLED {
    color: #e12d1b;
  }
  &--OUT_FOR_SIGNATURE {
    color: #4282ff;
  }
  &--SIGNED,
  &--Yes {
    color: #61b90c;
  }
}
</style>
